"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BillingMethodECheck = void 0;

var Interfaces_1 = require("../../Interfaces");

var Errors_1 = require("../../Errors");

var BillingMethodECheck =
/** @class */
function () {
  function BillingMethodECheck(eCheckInfo) {
    this.bankAccountNumber = BillingMethodECheck.formatBankAccountNumber(eCheckInfo.bankAccountNumber);
    this.bankRoutingNumber = BillingMethodECheck.formatBankRoutingNumber(eCheckInfo.bankRoutingNumber);
    this.driverLicenseNumber = BillingMethodECheck.formatDriversLicenseNumber(eCheckInfo.driverLicenseNumber);
    this.driverLicenseIssuingState = BillingMethodECheck.formatDriversLicenseIssuingState(eCheckInfo.driverLicenseIssuingState);
    this.checkNumber = BillingMethodECheck.formatCheckNumber(eCheckInfo.checkNumber);
  }

  BillingMethodECheck.formatBankAccountNumber = function (bankAccountNumber) {
    BillingMethodECheck.isValidBankAccountNumber(bankAccountNumber);
    return bankAccountNumber;
  };

  BillingMethodECheck.isValidBankAccountNumber = function (bankAccountNumber) {
    if (!/^\d{4,17}$/.test(bankAccountNumber)) {
      throw new Errors_1.PaymentValidationError('Bank account number contains illegal characters or has illegal format. Only numbers are allowed', Interfaces_1.PaymentErrorShortCodes.invalid_bank_account_number);
    }

    return true;
  };

  BillingMethodECheck.formatBankRoutingNumber = function (bankRoutingNumber) {
    BillingMethodECheck.isValidBankRoutingNumber(bankRoutingNumber);
    return bankRoutingNumber;
  };

  BillingMethodECheck.isValidBankRoutingNumber = function (bankRoutingNumber) {
    if (!/^\d{6,9}$/.test(bankRoutingNumber)) {
      throw new Errors_1.PaymentValidationError('Bank routing number contains illegal characters or has illegal format. Only numbers are allowed', Interfaces_1.PaymentErrorShortCodes.invalid_bank_routing_number);
    }

    return true;
  };

  BillingMethodECheck.formatDriversLicenseNumber = function (driversLicenseNumber) {
    BillingMethodECheck.isValidDriversLicenseNumber(driversLicenseNumber);
    return driversLicenseNumber;
  };

  BillingMethodECheck.isValidDriversLicenseNumber = function (driversLicenseNumber) {
    if (!/^[a-zA-Z0-9]{1,33}$/.test(driversLicenseNumber)) {
      throw new Errors_1.PaymentValidationError("Driver's license number contains illegal characters or has illegal format. Only numbers and letters are allowed", Interfaces_1.PaymentErrorShortCodes.invalid_driver_license_number);
    }

    return true;
  };

  BillingMethodECheck.formatDriversLicenseIssuingState = function (driversLicenseIssuingState) {
    BillingMethodECheck.isValidDriversLicenseIssuingState(driversLicenseIssuingState);
    return driversLicenseIssuingState;
  };

  BillingMethodECheck.isValidDriversLicenseIssuingState = function (driversLicenseIssuingState) {
    if (!/^[a-zA-Z]{2}$/.test(driversLicenseIssuingState)) {
      throw new Errors_1.PaymentValidationError("Driver's license issuing state contains illegal characters or has illegal format. Only letters are allowed", Interfaces_1.PaymentErrorShortCodes.invalid_driver_license_issuing_state);
    }

    return true;
  };

  BillingMethodECheck.formatCheckNumber = function (checkNumber) {
    BillingMethodECheck.isValidCheckNumber(checkNumber);
    return checkNumber;
  };

  BillingMethodECheck.isValidCheckNumber = function (checkNumber) {
    if (!/^\d{1,7}$/.test(checkNumber)) {
      throw new Errors_1.PaymentValidationError('Check number contains illegal characters or has illegal format. Only numbers are allowed', Interfaces_1.PaymentErrorShortCodes.invalid_check_number);
    }

    return true;
  };

  return BillingMethodECheck;
}();

exports.BillingMethodECheck = BillingMethodECheck;